<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="账号信息" name="first" :key="'first'">
        <childTab1/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import AcctAddMain from "@/views/SystemManagement/AcctManage/TabChild/AcctAddMain";

export default {
  name: "AcctAdd",
  components: {
    childTab1: AcctAddMain,
  },
  data() {
    return {
      activeName: "first",
    }
  },
}
</script>

<style scoped>

</style>